/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       GatePublicColorImage.tsx
 * @author     Christian Ascone
 * @date       9/20/19 10:59 AM
 */

import React from 'react';
import {Image} from "react-native";

export function GatePublicColorImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/public_color.png')
            }
        />
    );
}